import { Box, Typography } from "@mui/material"
import { fileUrl } from "api/api"
import { ReviewProps } from "api/application/manageWeb-interface"
import StarActive from "assets/icon/starActive"
import { notiError } from "component/notifications/notifications"
import { ContentState, EditorState } from "draft-js"
import htmlToDraft from "html-to-draftjs"
import SwitchButton from "new-components/buttons/switch-button"
import TextAreaInput from "new-components/inputs/text-area-input"
import InputTextEditor from "new-components/inputs/text-editor"
import TextInput from "new-components/inputs/text-input"
import UploadImage from "new-components/upload/upload-image"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

type ReviewFormProps = {
    dataEdit: any
    setDataEdit: (data: any) => void
    errorMessage: any
}

const ReviewForm = (props: ReviewFormProps) => {
    const { t } = useTranslation()
    const maxHeight = 1080
    const maxWidth = 1080
    const t_REVIEW = "MANAGE_WEB.REVIEW"

    const [dataEdit, setDataEdit] = useState<any>(props.dataEdit)
    const [dataEditId, setDataEditId] = useState<any>(props.dataEdit)
    const [score, setScore] = useState<number>(0)
    const [scoreHover, setScoreHover] = useState<number>(0)
    const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())

    const onLoadEdit = () => {
        const data = {
            ...props.dataEdit,
            status: !props.dataEdit?.reviewId && "ACTIVE" || props.dataEdit?.status
        }
        setDataEdit(data)
        setDataEditId(data)
        setScore(data?.score || 0)
        if (data?.content) {
            const newHTML: any = data?.content
            const blocksFromHTML = htmlToDraft(newHTML);
            const content = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap,
            );
            setEditorState(EditorState.createWithContent(content))
        }
    }

    useEffect(() => {
        onLoadEdit()
    }, [])

    const renderStarScoreClick = () => {
        const newEmptyArray = Array(5).fill(null);
        const onClickStar = (scoreCurrent: number) => {
            if (score === scoreCurrent) {
                setScore(0)
            } else {
                setScore(scoreCurrent)
            }
        }
        const renderStar = newEmptyArray.map((item: any, index: number) => {
            return (
                <Box key={index} onClick={() => onClickStar(index + 1)} display='flex' flexDirection='column' alignItems='center' marginRight='12px'>
                    <Box
                        onMouseEnter={() => setScoreHover(index + 1)}
                        onMouseLeave={() => setScoreHover(0)}
                        sx={{
                            'svg path': { transition: `all ${0.02 * index + 1}s` },
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '50px',
                            height: '45px',
                            borderRadius: '3px',
                            border: '1px solid #E5E5E5',
                            cursor: 'pointer'
                        }}>
                        <StarActive
                            stroke='#F6E331'
                            fill={(scoreHover !== 0 ? scoreHover : score) < index + 1 ? 'transparent' : '#F6E331'}
                        />
                    </Box>
                    <Box>{index + 1}</Box>
                </Box>

            )
        })
        return renderStar
    }

    const uploadNewsImageSign = (files: any) => {
        if (files[0]) {
            const file = files[0];
            const fileName = file.name.split(".");
            const detailImage = {
                base64: "",
                type: dataEditId?.fileType || "",
                fileExtension: fileName[fileName.length - 1],
                fileSize: file.size.toString(),
                fileId: dataEditId?.reviewId || 0,
            };
            const reader: any = new FileReader();
            reader.addEventListener("load", () => {
                const image = new Image();
                image.src = reader?.result as string;
                image.addEventListener("load", () => {
                    const width = image.width;
                    const height = image.height;

                    if (maxHeight < height || maxWidth < width) {
                        const errorWidth = maxWidth < width && ` ${t('MANAGE_WEB.BANNER.ERROR_WIDTH')} ${maxWidth} ` || ''
                        const errorHeight = maxHeight < height && ` ${t('MANAGE_WEB.BANNER.ERROR_HEIGHT')} ${maxHeight} ` || ''
                        const error = `${t('MANAGE_WEB.REVIEW.IMAGE')}  ${errorWidth} ${maxHeight < height && maxWidth < width && ` ${t('MANAGE_WEB.CONNECTOR.AND')} ` || ''} ${errorHeight}`
                        notiError(error)
                    } else {
                        const base64 = reader.result.split(",");
                        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result;
                        const newData = { ...dataEdit, ...detailImage, base64Show: reader.result, }
                        setDataEdit(newData)
                    }
                });
            });
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        renderDataSave()
    }, [score, editorState, dataEdit])

    const renderDataSave = () => {
        let newDataFile = {}
        if (dataEdit?.base64Show) {
            newDataFile = {
                file: {
                    fileId: dataEdit?.reviewId || 0,
                    base64: dataEdit?.base64 || '',
                    type: dataEdit?.fileType || '',
                    fileExtension: dataEdit?.fileExtension || '',
                    fileSize: dataEdit?.fileSize || ''
                }
            }
        }
        const info: ReviewProps = {
            status: dataEdit?.status,
            score: score || 0,
            content: dataEdit?.content || '',
            topic: dataEdit?.topic || "",
            subTopic: dataEdit?.subTopic || ""
        }

        const newData: ReviewProps = { ...info, ...newDataFile }
        props?.setDataEdit(newData)

    }

    return (
        <Box>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxHeight: {
                    xs: '70vh',
                    sm: '70vh',
                    md: '70vh',
                    lg: '65vh',
                    xl: '70vh',
                }, paddingRight: '16px',
                overflowY: 'auto',
            }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ paddingTop: '8px', width: '50%' }}>
                        <TextInput
                            label={t(`${t_REVIEW}.LABEL_TOPIC`)}
                            value={dataEdit?.topic}
                            onChange={(e: any) => { setDataEdit({ ...dataEdit, topic: e.target.value }) }}
                            fullWidth
                            required
                            helperText={props.errorMessage.EMPTY_TOPIC}
                        />
                    </Box>
                    <Box sx={{ marginTop: '8px', justifyContent: 'flex-end' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" gap={2} >
                            <Typography fontSize="16px" fontWeight={400}>{t(`${t_REVIEW}.LABEL_STATUS`)}</Typography>
                            <SwitchButton checked={dataEdit?.status === 'ACTIVE' ? true : false} onChange={() => setDataEdit({ ...dataEdit, status: dataEdit?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' })} />
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ paddingTop: '8px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ marginTop: '16px' }}>
                        <Box fontWeight='500'>{t(`${t_REVIEW}.SCORE_SERVICE`)}</Box>
                        <Box display='flex' alignItems='center' marginTop='12px'>{renderStarScoreClick()}</Box>
                    </Box>
                </Box>
                <Box sx={{ marginTop: '8px', width: '50%' }}>
                    <Box sx={{ fontWeight: '500' }}>{t(`${t_REVIEW}.UP_PIC`)}</Box>
                    <Box sx={{ marginTop: '12px', height: dataEdit?.filePath || dataEdit?.base64Show ? 'auto' : '350px' }}>
                        <Box sx={{ width: "100%", height: "100%", ".MuiFormControl-root": { height: '100%' } }} >
                            <UploadImage
                                canDelete={true}
                                onDelete={() => setDataEdit({ ...dataEdit, base64Show: '', filePath: '', fileName: '', fileType: '' })}
                                setValue={uploadNewsImageSign}
                                pathFile={dataEdit?.base64Show || dataEdit?.filePath && `${fileUrl}/${dataEdit?.filePath}/${dataEdit?.fileName}` || ''}
                                height={'100%'}
                                maxWidth={maxWidth}
                                maxHeight={maxHeight}
                            />
                            <Box sx={{ color: "#BBBBBB", marginTop: "8px" }}>
                                {'('}{t(`${t_REVIEW}.FILESIZE`)}{` ${maxWidth} x ${maxHeight} px)`}
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ marginTop: '48px' }}>
                    <TextAreaInput
                        label={t(`${t_REVIEW}.LABEL_SUBTOPIC`)}
                        value={dataEdit?.subTopic}
                        onChange={(e) => { setDataEdit({ ...dataEdit, subTopic: e.target.value }) }}
                        fullWidth
                    />
                </Box>
                <Box sx={{ marginTop: '48px' }}>
                    <Box sx={{ fontWeight: '500' }}> {t(`${t_REVIEW}.DETAIL`)} </Box>
                    <Box width={'100%'} marginTop={'16px'}>
                        {(dataEdit?.reviewId) && (
                            <InputTextEditor
                                value={dataEdit?.content}
                                setValue={(e) => {
                                    setDataEdit({ ...dataEdit, content: e })
                                }}
                            />
                        ) || <></>}
                        {(!dataEdit?.reviewId) && (
                            <InputTextEditor
                                value={dataEdit?.content}
                                setValue={(e) => {
                                    setDataEdit({ ...dataEdit, content: e })

                                }}
                            />
                        ) || <></>}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default ReviewForm